import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import { config } from '@/config';
import { captureUrlToken } from '@/features/auth';
import { logBuildInfo } from '@/lib/utils';

import { App } from './app/App';
import '@/styles/globals.scss';

logBuildInfo({
  version: config.appVersion,
  environment: config.appEnv,
  commitSha: config.commitSha,
});

captureUrlToken();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found in index.html');

if (config.appEnv === 'development') {
  document.body.classList.add('env-dev');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
